import { useState, useEffect, useCallback } from "react";

export function useNetworkStatus() {
    const [isOnline, setIsOnline] = useState(navigator.onLine);

    const checkConnection = useCallback(async () => {
        try {
            // Try to fetch a small resource to verify actual connectivity
            await fetch("https://httpbin.org/get", {
                method: "HEAD",
                mode: "no-cors",
                cache: "no-store",
            });
            setIsOnline(true);
            return true;
        } catch (error) {
            setIsOnline(false);
            return false;
        }
    }, []);

    useEffect(() => {
        const handleOnline = () => {
            setIsOnline(true);
        };

        const handleOffline = () => {
            setIsOnline(false);
        };

        window.addEventListener("online", handleOnline);
        window.addEventListener("offline", handleOffline);

        // Initial check
        checkConnection();

        // Periodic check every 5 seconds
        const intervalId = setInterval(checkConnection, 5000);

        return () => {
            window.removeEventListener("online", handleOnline);
            window.removeEventListener("offline", handleOffline);
            clearInterval(intervalId);
        };
    }, [checkConnection]);

    return { isOnline, checkConnection };
}
